import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ScrollToTop } from "../../components/ScrollToTop";
import { useScrollAtBottom } from "../../hooks";

type IOverlaySupport = {
    footerHeightRem: number,
    preFooterHeightRem?: number
}

export const OverlaySupport = ({ footerHeightRem, preFooterHeightRem = 0 }:IOverlaySupport) => {

  const theme = useTheme();
  const { t } = useTranslation();
  const { isScrolling } = useScrollAtBottom({});

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // horizontal offset from the right edge: version sits to the LEFT of the scroll-to-top
  // button when it is visible, otherwise it takes the button's own spot
  const versionRight = isScrolling ? (isMobile ? "5rem" : "6rem") : "2rem";

  let footerOffset = (isMobile ? footerHeightRem - 4 : footerHeightRem) + (preFooterHeightRem + 1);

  return (
    <Stack id="overlayTrailStickyElements"
      sx={ {
        pointerEvents: "none",
        position: "absolute",
        height: `calc(100% - ${!isMobile ? footerOffset : "0"}rem)`, // in mobile the overlay box is placed on the bottom of the footer
        top: 0,
        right: 0,
        zIndex: 9
      } }
    >
      <Stack id="stickyElements"  sx={ {
        position: "sticky",
        alignItems: "flex-end",
        top: `calc(100% - ${!isMobile ? footerOffset : 13 + preFooterHeightRem}rem)`, // in mobile the overlay box is placed on the bottom of the footer and need a fixed offset (13rem)
        gap: isMobile ? "2rem" : "4rem",
        zIndex: 9
      } }
      >
        <ScrollToTop />
      </Stack>
      <Stack
        alignItems="center"
        direction="row"
        sx={ {
          bottom: isMobile ? "4.5rem" : 0, // above the fixed mobile bottom-nav (62px)
          height: isMobile ? "2.5rem" : "3rem",
          pointerEvents: "none",
          position: "absolute",
          right: isMobile ? "1rem" : versionRight,
          transition: "right 0.2s ease-in-out"
        } }
      >
        <Typography
          sx={ {
            color: theme.palette.text?.primary,
            fontSize: isMobile ? "0.75rem" : "0.875rem",
            whiteSpace: "nowrap"
          } }
        >
          { t("version-label") } { import.meta.env.PACKAGE_VERSION }
        </Typography>
      </Stack>
    </Stack>
  );
};
